import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../store/hooks';
import { fetchAutoparkById } from '../../store/admin/autoparkSlice';
import { AutoparkService, IAutopark } from '../../services/autopark.service';
import { formatMoney } from '../../utils/money';
import './adminAutoparks.css';

interface AdminAutoparksProps {
  refreshTrigger?: number;
}

function AdminAutoparks({ refreshTrigger }: AdminAutoparksProps) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [autoparks, setAutoparks] = useState<IAutopark[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  // Функция для загрузки автопарков
  const fetchAutoparks = async (page = currentPage) => {
    try {
      setLoading(true);
      setError(null);
      const response = await AutoparkService.getAutoparks(page, 10);
      setAutoparks(response.data);
      setTotalCount(response.totalCount);
    } catch (error: any) {
      setError(error.message || 'Ошибка при загрузке автопарков');
    } finally {
      setLoading(false);
    }
  };

  // Загрузка автопарков при монтировании и изменении страницы
  useEffect(() => {
    fetchAutoparks();
  }, [currentPage]);

  // Обновление при изменении refreshTrigger
  useEffect(() => {
    if (refreshTrigger && refreshTrigger > 0) {
      fetchAutoparks();
    }
  }, [refreshTrigger]);

  const handleCardClick = async (autoparkId: string) => {
    // Загружаем детальные данные автопарка в Redux
    await dispatch(fetchAutoparkById(autoparkId));
    // Переходим на страницу деталей
    navigate(`/account/autopark/${autoparkId}`);
  };

  return (
    <div className="admin-autoparks">
      {/* Заголовок таблицы */}
      <div className="table-header">
        <div className="table-header__cell">
          <span>Наименование</span>
          {/* <svg className="sort-icon sort-icon--active" width="20" height="20" viewBox="0 0 19 13" fill="none">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0.75C0 0.335786 0.335786 0 0.75 0H17.75C18.1642 0 18.5 0.335786 18.5 0.75C18.5 1.16421 18.1642 1.5 17.75 1.5H0.75C0.335786 1.5 0 1.16421 0 0.75ZM14.7197 3.21967C15.0126 2.92678 15.4874 2.92678 15.7803 3.21967L18.2803 5.71967C18.5732 6.01256 18.5732 6.48744 18.2803 6.78033C17.9874 7.07322 17.5126 7.07322 17.2197 6.78033L16 5.56066V11.75C16 12.1642 15.6642 12.5 15.25 12.5C14.8358 12.5 14.5 12.1642 14.5 11.75V5.56066L13.2803 6.78033C12.9874 7.07322 12.5126 7.07322 12.2197 6.78033C11.9268 6.48744 11.9268 6.01256 12.2197 5.71967L14.7197 3.21967ZM0 5.75C0 5.33579 0.335786 5 0.75 5H8.75C9.16421 5 9.5 5.33579 9.5 5.75C9.5 6.16421 9.16421 6.5 8.75 6.5H0.75C0.335786 6.5 0 6.16421 0 5.75ZM0 10.75C0 10.3358 0.335786 10 0.75 10H9.75C10.1642 10 10.5 10.3358 10.5 10.75C10.5 11.1642 10.1642 11.5 9.75 11.5H0.75C0.335786 11.5 0 11.1642 0 10.75Z"
              fill="#1D61E7"
            />
          </svg> */}
        </div>
        <div className="table-header__cell">
          <span>Адрес</span>
          {/* <svg className="sort-icon" width="20" height="20" viewBox="0 0 19 13" fill="none">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0.75C0 0.335786 0.335786 0 0.75 0H17.75C18.1642 0 18.5 0.335786 18.5 0.75C18.5 1.16421 18.1642 1.5 17.75 1.5H0.75C0.335786 1.5 0 1.16421 0 0.75ZM14.7197 3.21967C15.0126 2.92678 15.4874 2.92678 15.7803 3.21967L18.2803 5.71967C18.5732 6.01256 18.5732 6.48744 18.2803 6.78033C17.9874 7.07322 17.5126 7.07322 17.2197 6.78033L16 5.56066V11.75C16 12.1642 15.6642 12.5 15.25 12.5C14.8358 12.5 14.5 12.1642 14.5 11.75V5.56066L13.2803 6.78033C12.9874 7.07322 12.5126 7.07322 12.2197 6.78033C11.9268 6.48744 11.9268 6.01256 12.2197 5.71967L14.7197 3.21967ZM0 5.75C0 5.33579 0.335786 5 0.75 5H8.75C9.16421 5 9.5 5.33579 9.5 5.75C9.5 6.16421 9.16421 6.5 8.75 6.5H0.75C0.335786 6.5 0 6.16421 0 5.75ZM0 10.75C0 10.3358 0.335786 10 0.75 10H9.75C10.1642 10 10.5 10.3358 10.5 10.75C10.5 11.1642 10.1642 11.5 9.75 11.5H0.75C0.335786 11.5 0 11.1642 0 10.75Z"
              fill="#CACACA"
            />
          </svg> */}
        </div>
        <div className="table-header__cell">
          <span>ИНН</span>
        </div>
        <div className="table-header__cell">
          <span>Торговое название</span>
        </div>
        <div className="table-header__cell">
          <span>Баланс</span>
        </div>
        <div className="table-header__cell">{/* Пустая колонка для действий */}</div>
      </div>

      {/* Содержимое таблицы */}
      <div className="table-content">
        {loading ? (
          <div className="loading-state">Загрузка автопарков...</div>
        ) : error ? (
          <div className="error-state">{error}</div>
        ) : autoparks.length === 0 ? (
          <div className="loading-state">Автопарки не найдены</div>
        ) : (
          autoparks.map((autopark) => (
            <div key={autopark.id} className="table-row">
              <div className="table-row__cell table-row__cell--name">
                {autopark.tradeName || autopark.legalName || 'Наименование'}
              </div>
              <div className="table-row__cell table-row__cell--address">
                {autopark.actualAddress || autopark.legalAddress || 'Адрес'}
              </div>
              <div className="table-row__cell table-row__cell--inn">{autopark.inn || 'ИНН'}</div>
              <div className="table-row__cell table-row__cell--trade-name">
                {autopark.tradeName || 'Торговое название'}
              </div>
              <div className="table-row__cell table-row__cell--balance">{`${formatMoney(autopark.balance)} Р`}</div>
              <div className="table-row__cell table-row__cell--action">
                <button className="card-button" onClick={() => handleCardClick(autopark.id)}>
                  Карточка парка
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default AdminAutoparks;
